import { QueryClient } from '@tanstack/react-query';

// Default query options following TanStack Query best practices
const defaultQueryOptions = {
  queries: {
    // Data is considered stale after 5 minutes
    staleTime: 5 * 60 * 1000,
    // Inactive queries are garbage collected after 10 minutes
    gcTime: 10 * 60 * 1000,
    // Retry failed requests up to 3 times with exponential backoff
    retry: (failureCount: number, error: Error) => {
      // Don't retry on authentication errors
      if (error.message?.includes('Authentication failed') || error.message?.includes('401')) {
        return false;
      }
      // Don't retry on client errors (4xx)
      if (error.message?.includes('400') || error.message?.includes('404')) {
        return false;
      }
      return failureCount < 3;
    },
    // Don't refetch on window focus by default (can be overridden per query)
    refetchOnWindowFocus: false,
    // Refetch on reconnect
    refetchOnReconnect: true,
    // Refetch on mount if data is stale
    refetchOnMount: true,
  },
  mutations: {
    // Retry mutations once on failure
    retry: 1,
  },
};

// Create and configure the QueryClient
export const queryClient = new QueryClient({
  defaultOptions: defaultQueryOptions,
});
